<div class="container-fluid">
  <div class="invoiceWrapper">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
            <div class="headerWrapper">
              <h4>Scanned Implants</h4>    
	              <div class="buttonWrapper ">
	                <button *ngIf="mobile === true" (click)="navMobileScan()" class="btn btn-success btn-sm" mat-raised-button><i
	                  aria-hidden="true" class="fa fa-barcode"></i>Scan Implant
	                </button>                          
	              </div>          
            </div>
            <div class="customModal">
            </div>
            <table class="table table-bordered" *ngIf="viewPermission === true">
              <thead>
              <tr>
                <th class="col1">Product Code</th>
                <th class="col2">PO No</th>
                <th class="col3">Inv.No</th>
                <th class="col4">Batch No</th>
                <th class="col5">Expiry</th>
                <th class="col6">Product Name</th>
                <th class="col7">Scanned On</th>  
                
                <!-- <th class="col5">Scanned On</th>   -->        
              </tr>
              </thead>
              <tbody>
              <!-- (dblclick)="editDialog(selectedIndex)" -->
              
                   <tr rowspan=""
                  *ngFor="let in of scannedImplants | paginate: { id: 'stockPageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index; " [ngClass]="{'sel': i === selectedIndex }"
                  style="height: 36px;">
                <td scope="col8">{{ in.product_code }}</td>
                <td class="col9">{{ in. po_id }}</td> 
                <td class="col10">{{ in. invoice_id }}</td> 
                <td class="col11">{{ in.batch_no }}</td>
                <td class="col12">{{ in.expiry_date }}</td>
                <td class="col13">{{ in.name }}</td>
                <td class="col14">{{ in. scanned_date }}</td> 
                

                
              </tr>
              </tbody>
            </table>
            <div class="footerWrapper row ">
              <div class="col-lg-7 col-md-12 col-sm-12">
                <div class="input-group  ">
                  <select name="searchBy" [(ngModel)]="searchBy" (change)="setSearchPlaceHolder()" data-show-content="true" class="form-control">
                    <option [ngValue]="0"> Product Code </option>
                    <option [ngValue]="1"> PO No </option>
                    <option [ngValue]="2"> Invoice No </option>
                    <option [ngValue]="3"> Batch No </option>
                    <option [ngValue]="4"> Expiry Date</option>
                    <option [ngValue]="5"> Scanned Date </option>
                  </select>

                  <input type="text" placeholder="{{placeHolder}}" class="form-control" name="searchTxt" [(ngModel)]="searchTxt">

                  <span class="input-group-text" (click)="doSearch()">
                      <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                  <span class="input-group-text" (click)="doRefresh()">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                  </span>

                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12">
                <app-common-page [id]="stockPageId" (pageChange)="doPaginate($event)">
                </app-common-page>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </div>
</div>
